export const ABOUT_US_PAGE_LOADER = "ABOUT_US_PAGE_LOADER";
export const ABOUT_US_PAGE_SUCCESS = "ABOUT_US_PAGE_SUCCESS";
export const ABOUT_US_PAGE_FAILURE = "ABOUT_US_PAGE_FAILURE";
export const ABOUT_US_PAGE_RESET = "ABOUT_US_PAGE_RESET";